import React, { useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { adsContext } from '../UseContext/AdsContext';


const Media = () => {

  const navigate = useNavigate();

  const fileInputRef = useRef(null);

  // handle image click
  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  // handle file change
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    // Update the media array in the ad state
    setAd((prevAd) => ({
      ...prevAd,
      media: [...prevAd.media, ...files],
    }));
  };

  // handle remove media file
  const handleRemoveMedia = (index) => {
    setAd((prevAd) => ({
      ...prevAd,
      media: prevAd.media.filter((_, i) => i !== index),
    }));
  };

  const { ad, setAd } = useContext(adsContext);

  return (
    <>
      <section className='d-flex flex-column flex-xl-row gap-3 mb-3'>
        {/* Left Block */}
        <div className='create-campaign-left-block bg-light p-3 rounded-3 shadow-sm'>
          {/* Categories & Sub Categories */}
          <div className='bg-white p-3 rounded-3 shadow-sm mb-3'>
            {/* Categories */}
            <div className='mb-4'>
              <h5 className='mb-0'>Categories</h5>

              <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

              <select className="form-select mt-1" value={ad.categories} onChange={(e) => setAd({ ...ad, categories: e.target.value })}>
              <option value='' disabled>Select your categories</option>
                <option value="category-1">Category 1</option>
                <option value="category-2">Category 2</option>
                <option value="category-3">Category 3</option>
                <option value="category-4">Category 4</option>
                <option value="category-5">Category 5</option>
              </select>
            </div>

            {/* Sub Categories */}
            <div className='mb-4'>
              <h5 className='mb-0'>Sub Categories</h5>

              <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

              <select className="form-select mt-1" value={ad.subCategories} onChange={(e) => setAd({ ...ad, subCategories: e.target.value })}>
                <option value='' disabled>Select your sub category</option>
                <option value="sub-category-1">Sub Category 1</option>
                <option value="sub-category-2">Sub Category 2</option>
                <option value="sub-category-3">Sub Category 3</option>
                <option value="sub-category-4">Sub Category 4</option>
                <option value="sub-category-5">Sub Category 5</option>
              </select>
            </div>
          </div>

          {/* Ad Creative */}
          <div className='bg-white p-3 rounded-3 shadow-sm mb-3'>
            <h5 className='mb-0'>Ad Creative</h5>

            <small className='text-secondary'>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Maiores asperiores illo placeat iusto et voluptatum blanditiis eius, id autem provident?</small>

            {/* Creative Type */}
            {/* <div className='my-4'>
              <h5 className='mb-0'>Creative Type</h5>

              <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

              <select className="form-select mt-1">
                <option selected>Single image or video</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </select>
            </div> */}

            {/* Headline */}
            <div className='my-4'>
              <h5 className='mb-0'>Headline</h5>

              <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

              <input type="text" className='form-control mt-1' value={ad.headline} onChange={(e) => setAd({ ...ad, headline: e.target.value })} placeholder='Write a short headline...' />
            </div>

            {/* Media */}
            <div className='mb-4'>
              <h5 className='mb-3'>Media</h5>

              <div className='d-flex flex-wrap gap-3'>
                <>
                  {
                    ad.media.length < 5
                    &&
                    <div className='d-flex flex-column align-items-center justify-content-center rounded-3 p-3' style={{ border: '1px dashed gray', width: '200px' }} onClick={handleImageClick}>
                      <img src="/images/icons/add-photo-blue.svg" style={{ height: '100px' }} alt="add-photo-blue" />
                      <span>Add File</span>
                      <input ref={fileInputRef} type="file" multiple accept="image/*,video/*" style={{ display: 'none' }} onChange={handleFileChange} />
                    </div>
                  }
                </>

                {/* Add Media */}
                <>
                  {
                    ad.media.length > 0
                    &&
                    ad.media.map((value, index) => (
                      <>
                        {
                          value.type.slice(0, 5) === 'image'
                          ?
                          <div className='position-relative' key={index}>
                            <img src={URL.createObjectURL(value)} className='border rounded-3 shadow-sm' style={{ height: '200px', width: '200px' }} alt="media" />

                            <div className='bg-secondary p-1 pt-0 rounded-3 position-absolute top-0 end-0 mt-2 me-2 cursor-pointer' onClick={() => handleRemoveMedia(index)}>
                              <img src="/images/icons/delete-white.svg" className='' style={{ height: '20px' }} alt="delete" />
                            </div>
                          </div>
                          :
                          <div className='position-relative' key={index}>
                            <video className='border rounded-3 shadow-sm' style={{ height: '200px', width: '200px' }} autoPlay loop>
                              <source src={URL.createObjectURL(value)} type={value.type} />
                            </video>

                            <div className='bg-secondary p-1 pt-0 rounded-3 position-absolute top-0 end-0 mt-2 me-2 cursor-pointer' onClick={() => handleRemoveMedia(index)}>
                              <img src="/images/icons/delete-white.svg" className='' style={{ height: '20px' }} alt="delete" />
                            </div>
                          </div>
                        }
                      </>
                    ))
                  }
                </>
              </div>
            </div>

            {/* Website */}
            <div className='border p-3 rounded-3 my-3'>
              <div>
                <h5 className="fw-semibold mb-0" htmlFor="custom">Website</h5>
                <small className='text-secondary'>Send people to your website.</small>

                {/* Display Link */}
                <div className='my-4'>
                  <h5 className='mb-0'>Display Link</h5>

                  <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

                  <input type="text" className='form-control mt-1' value={ad.websiteDisplayLink} onChange={(e) => setAd({ ...ad, websiteDisplayLink: e.target.value })} placeholder='www.example.com...' />
                </div>

                {/* URL */}
                <div>
                  <h5 className='mb-0'>URL</h5>

                  <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, ipsam!</small>

                  <input type="text" className='form-control mt-1' value={ad.websiteRedirectUrl} onChange={(e) => setAd({ ...ad, websiteRedirectUrl: e.target.value })} placeholder='http://www.example.com...' />
                </div>
              </div>
            </div>

            {/* Main Text */}
            <div className='mb-4'>
              <h5 className='mb-0'>Main Text</h5>

              <small className='text-secondary'>Lorem ipsum dolor sit amet consectetur adipisicing elit. dolor sit amet consectetur adipisicing elit. dolor sit amet consectetur adipisicing elit. Perferendis aperiam a veritatis nostrum sapiente iste, obcaecati eum quam quibusdam! Impedit.</small>

              <div className="form-floating mt-1">
                <textarea className="form-control" value={ad.mainText} onChange={(e) => setAd({ ...ad, mainText: e.target.value })} id="floatingTextarea2" style={{ height: '100px' }} placeholder="Write your main text here..."></textarea>
                <label htmlFor="floatingTextarea2">Write your main text here...</label>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className='d-flex align-items-center justify-content-between gap-3 flex-wrap'>
            <button type="button" className='btn btn-success flex-grow-1'>Save Draft</button>
            <button type="button" className='btn bg-secondary-subtle text-primary flex-grow-1' onClick={() => navigate(`/campaigns/basic-info`)}>Show Preview</button>
            <button type="button" className='btn bg-secondary-subtle flex-grow-1'>Cancel</button>
            <button type="button" className='btn btn-primary flex-grow-1' onClick={() => navigate(`/campaigns/parameters`)}>Next</button>
          </div>
        </div>

        {/* Right Block */}
        <div className='create-campaign-right-block bg-light p-3 rounded-3 shadow-sm'>Right Block</div>
      </section>  
    </>
  );
};

export default Media;